import { render, staticRenderFns } from "./FreeEditionIntroduction.vue?vue&type=template&id=5564562a&scoped=true"
import script from "./FreeEditionIntroduction.vue?vue&type=script&lang=js"
export * from "./FreeEditionIntroduction.vue?vue&type=script&lang=js"
import style0 from "./FreeEditionIntroduction.vue?vue&type=style&index=0&id=5564562a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564562a",
  null
  
)

export default component.exports